


























import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'

@Component({
  components: {
    Modal,
    Button,
  },
})
export default class TransferPickupSuccessModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({
    type: String,
    default: 'Berhasil Transfer pick up',
  })
  readonly successText!: string

  onClose(): void {
    this.$emit('close')
  }
}
